import { TimePicker } from 'antd';
import * as React from 'react';

const defaultFormat = 'HH:mm';

interface TimeFieldProps {
  onChanged?: (any) => any;
}

const TimeField: React.FC<TimeFieldProps> = ({ ...props }) => (
  <TimePicker {...props} format={defaultFormat} />
);

export default TimeField;
